import Vue from 'vue'
import {adminRoles, taskAssignGroupsAdvancedSearch, UserRoleEnum} from '@/enums/userRolesEnum'
import {HTTP} from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import {BallPulseLoader} from 'vue-loaders';

import StateControl from '@/componentsReusable/StateControl.vue'
import CustomDropdownControl from '@/componentsReusable/CustomDropdownControl.vue'
import ButtomToggleControl from '@/componentsReusable/ButtonToggleControl.vue'
import flatPickr from 'vue-flatpickr-component';
import {ViewStateType} from '@/enums/ViewStateType';

export default Vue.extend({
  name: 'TasksAdvancedSearch',
  data() {
    return {
      UserRoleEnum: UserRoleEnum,
      isAuthorized: false,
      processing: false,
      loadingSearchResults: false,

      searchCountResults: 0,
      allowForceResultsMaximum: 500,
      allowForceResults: false,
      searchResults: [],

      searchParametersCardExpanded: true,
      pullingReportData: false,

      advancedSearchFilters: {
        createdAfter: null,
        createdBefore: null,
        createdByAppUserIdFilters: [],
        currentAssignedUserIdFilters: [],
        historicalAssignedUserIdFilters: {
          filters: [],
          isAnd: false
        },
        isComplete: false,
        isNotComplete: false,
        taskId: null,
        taskContains: {
          idCounter: 0,
          placeholder: "",
          filters: [],
          isAnd: false
        },
      },

    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader,
    StateControl,
    CustomDropdownControl,
    flatPickr,
    ButtomToggleControl
  },
  computed: {
    users(): any[] {
      return this.$store.state.user.users.map((user: any) => {
        return {
          id: user.appUserId,
          name: user.firstName + ' ' + user.lastName
        }
      });
    },
    assigned(): any[] {
      let assignables : any[] = [ ...taskAssignGroupsAdvancedSearch ];
      assignables.push(...this.users);
      return assignables;
    }
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole'](adminRoles);
  },
  mounted: function () {
    if (this.$store.state.viewState[ViewStateType.TASK_SEARCH_ADVANCED]) {
      this.advancedSearchFilters = this.$store.state.viewState[ViewStateType.TASK_SEARCH_ADVANCED];
      this.searchTasks();
    }
  },
  methods: {

    addTextContains() {
      this.advancedSearchFilters.taskContains.placeholder = this.advancedSearchFilters.taskContains.placeholder.trim();
      if (!this.advancedSearchFilters.taskContains.placeholder) {
        return;
      }
      if (!this.advancedSearchFilters.taskContains.filters.find((filter: any) => {
        return filter.name === this.advancedSearchFilters.taskContains.placeholder;
      })) {
        this.advancedSearchFilters.taskContains.idCounter++;
        this.addFilter(this.advancedSearchFilters.taskContains.filters, {
          id: this.advancedSearchFilters.taskContains.idCounter,
          name: this.advancedSearchFilters.taskContains.placeholder
        });
      }
      this.advancedSearchFilters.taskContains.placeholder = "";
    },

    addFilter(filterList: any[], filter: any) {
      if (!filterList.some(((filterInstance: any) => filterInstance.id === filter.id))) {
        filterList.push(filter);
      }
    },

    removeFilter(filtersList: any[], filterIndex: number) {
      filtersList.splice(filterIndex, 1);
    },

    filterConjunctionUpdate(filterConjunctionBool: any, conjunctionBoo: boolean) {
      filterConjunctionBool = conjunctionBoo;
    },

    clearAll() {
      this.advancedSearchFilters.createdAfter = null;
      this.advancedSearchFilters.createdBefore = null;
      this.advancedSearchFilters.createdByAppUserIdFilters = [];
      this.advancedSearchFilters.currentAssignedUserIdFilters = [];
      this.advancedSearchFilters.historicalAssignedUserIdFilters.filters = [];
      this.advancedSearchFilters.historicalAssignedUserIdFilters.isAnd = false;
      this.advancedSearchFilters.isComplete = false;
      this.advancedSearchFilters.isNotComplete = false;
      this.advancedSearchFilters.taskId = null;
      this.advancedSearchFilters.taskContains.filters = [];
      this.advancedSearchFilters.taskContains.isAnd = false;
      this.advancedSearchFilters.taskContains.placeholder = '';

      this.$store.dispatch('viewState/updateViewState', {name: ViewStateType.TASK_SEARCH_ADVANCED, value: null});
    },

    async searchTasks(force: boolean = false) {
      if (this.processing) {
        return;
      }
      this.processing = true;
      this.loadingSearchResults = true;
      this.addTextContains();
      this.$store.dispatch('viewState/updateViewState', {name: ViewStateType.TASK_SEARCH_ADVANCED, value: JSON.parse(JSON.stringify(this.advancedSearchFilters))});
      try {
        const response = await HTTP.post('/api/tasks/advanced-search?forceResults=' + force, { advancedSearchFilters: this.advancedSearchFilters} );
        // If the response is a count, display the count message
        // If the response is a list, display the list
        // If the search results results are empty, display the count
        // If the count is greater than 0 display the count at the option to force retriving the results
        //  as long as the results are less than allowForceResultsMaximum

        const queryCountResults = response.data.data.count;

        this.searchCountResults = queryCountResults;
        this.searchResults = response.data.data.results;
        this.allowForceResults = queryCountResults < this.allowForceResultsMaximum;
      } catch {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Getting Results',
          text: 'Something went wrong getting search results!',
        });
      } finally {
        this.processing = false;
        this.loadingSearchResults = false;
      }
    },

    goToTasks() {
      this.$router.push({name: 'Tasks'});
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/tasks/TasksAdvancedSearch.ts